module.exports = __webpack_public_path__ + "img/madera012.3b74048b.jpg";